import axios from 'axios'
import { getHost } from './host'


/**
 * API call to post 'rv50_test` command to the monitor and returns the response
 *   
 * @param   {string}        api_key    API key of the current user
 * @param   {string}        id         Monitor id 
 * @param   {string}        command    The command that needs to be sent to the monitor
 * 
 * @return  {object}
 * 
 */
export async function postMonitorCommand(api_key: string, id: string, command: string){
  
    const url = `https://${getHost()}/api/monitor/${id}/command/${command}`

    const headers = {
        'X-API-KEY': api_key, Accept: 'application/json'
      };
    
    const response = await axios.post(url, null , { headers: headers });    

    return response
}

/**
 * API call to get the result of the last command of 'rv50_test` for the monitor
 *   
 * @param   {string}        api_key    API key of the current user
 * @param   {string}        id         Monitor id 
 * @param   {string}        command    The command that needs ti check the result of the monitor
 * 
 * @return  {object}
 * 
 */
export async function getMonitorCommand(api_key: string, id: string, command: string){  
  
    const url = `https://${getHost()}/api/monitor/${id}/command/${command}`

    const headers = {
        'X-API-KEY': api_key, Accept: 'application/json'
      };
    
    const { data } = await axios.get(url, { headers: headers });
      
    return data
}

